import {
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { GlobalVariables } from '../../../globalVar';
import { MuiTelInput } from 'mui-tel-input';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';

function ModalCCUpdate(props) {
  const { phoneCountryStr, jobString, notesString } = useTranslationHook();

  const weakPWErrorAlert = (missingRequirements) => {
    toast.dismiss();
    if (missingRequirements.length > 0) {
      toast.error(
        'La contraseña ingresada es débil. No cumple con los siguientes requisitos:',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );

      missingRequirements.forEach((requirement) => {
        toast.info(`${requirement}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  var contactEmailDefaultU = localStorage.getItem('contactEmailForUpdate');
  var contactNameDefaultU = localStorage.getItem('contactNameForUpdate');
  var contactLastNameDefaultU = localStorage.getItem(
    'contactLastNameForUpdate'
  );
  var contactTypeDefaultU = localStorage.getItem('contactTypeForUpdate');
  var contactPhoneDefaultU = localStorage.getItem('contactPhoneForUpdate');
  var contactCountryCodeDefaultU = localStorage.getItem(
    'contactCountryCodeForUpdate'
  );
  var contactJobDefaultU = localStorage.getItem('contactJobForUpdate');
  var contactNotesDefaultU = localStorage.getItem('contactNotesForUpdate');

  var contactClientDefaultU = localStorage.getItem('contactClientForUpdate');
  var contactSiteDefaultU = localStorage.getItem('contactSiteForUpdate');

  const [email, setEmail] = useState(contactEmailDefaultU);
  const [name, setName] = useState(contactNameDefaultU);
  const [lastName, setLastName] = useState(contactLastNameDefaultU);
  const [client, setClient] = useState(contactClientDefaultU);
  const [site, setSite] = useState(contactSiteDefaultU);
  const [password, setPW] = useState('');
  const [verifyPassword, setVPW] = useState('');
  const [contactTypeId, setContactTypeId] = useState(contactTypeDefaultU);
  const [phone, setPhone] = useState(contactPhoneDefaultU);
  const [countryCode, setCountryCode] = useState(contactCountryCodeDefaultU);
  const [job, setJob] = useState(contactJobDefaultU);
  const [notes, setNotes] = useState(contactNotesDefaultU);

  const resetFormFields = () => {
    console.log(localStorage.getItem('contactPhoneForUpdate'));
    setEmail(localStorage.getItem('contactEmailForUpdate'));
    setName(localStorage.getItem('contactNameForUpdate'));
    setLastName(localStorage.getItem('contactLastNameForUpdate'));
    setClient(localStorage.getItem('contactClientForUpdate'));
    setSite(localStorage.getItem('contactSiteForUpdate'));
    setPW('');
    setVPW('');
    setJob(localStorage.getItem('contactJobForUpdate'));
    setContactTypeId(localStorage.getItem('contactTypeForUpdate'));
    setPhone(localStorage.getItem('contactPhoneForUpdate'));
    setCountryCode(localStorage.getItem('contactCountryCodeForUpdate'));
    setJob(localStorage.getItem('contactJobForUpdate'));
    setNotes(localStorage.getItem('contactNotesForUpdate'));
  };

  function hide() {
    props.onHide();
    toast.dismiss();
    getToast({
      status: 'success',
      title: 'Contacto actualizado exitosamente en la base de datos.',
    });
    let endpoint = `${GlobalVariables.getURL()}listClientsContacts`;
    if (props.selectedClients.length > 0) {
      endpoint += `?id=${props.selectedClients}`;
    }
    props.getContacts(endpoint);
  }

  function updateContact(event) {
    event.preventDefault();
    var updateContactId = localStorage.getItem('contactIdToUpdate');
    if (password === verifyPassword) {
      customAxios
        .patch(
          `${GlobalVariables.getURL()}updateContact/${updateContactId}`,
          {
            name: name,
            last_names: lastName,
            email: email,
            password: password,
            telefono: phone,
            countryCode: countryCode,
            contact_type_id: contactTypeId,
            notes,
            job,
          },
          {
            headers: {
              Authorization: 'bearer ' + localStorage.getItem('token'),
            },
          }
        )
        .then(
          (response) => {
            console.log(response);
            hide();
          },
          (error) => {
            console.log(error);
            if (error.response.data.startsWith('Contraseña débil.')) {
              const requirements = [
                'Debe contener al menos una letra mayúscula.',
                'Debe contener al menos un número.',
                'Debe contener al menos un caracter especial (!@#$%^&*).',
                'Debe tener al menos 9 caracteres de longitud.',
              ];

              const missingRequirements = requirements.filter((requirement) =>
                error.response.data.includes(requirement)
              );

              weakPWErrorAlert(missingRequirements);
            } else if (error.response.data === 'Usuario ya existe.') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'Ya existe un usuario con esta información. Vuelve a intentarlo.',
              });
            } else {
              toast.dismiss();
              getToast({
                status: 'error',
                title: 'Error al actualizar contacto. Vuelve a intentarlo.',
              });
            }
          }
        );
    } else {
      toast.dismiss();
      getToast({
        status: 'error',
        title: 'Contraseñas no coinciden. Vuelve a intentarlo.',
      });
    }
  }

  return (
    <Modal
      onEntering={resetFormFields}
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar contacto
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="update-cc-form" onSubmit={updateContact}>
          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label="Plaza"
                type="text"
                value={client}
                InputLabelProps={{ shrink: true }}
                required
                disabled
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label="Sucursal"
                type="text"
                value={site}
                InputLabelProps={{ shrink: true }}
                required
                disabled
              />
            </div>
          </div>

          <br />
          <Divider>Información del contacto</Divider>
          <br />

          <div className="row">
            <div className="col-md-6">
              <TextField
                sx={{ width: '100%' }}
                label="Correo electrónico"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                // required
              />
            </div>
            <div className="col-md-6">
              <MuiTelInput
                sx={{ width: '100%' }}
                label="Teléfono"
                defaultCountry={countryCode}
                langOfCountryName={phoneCountryStr}
                value={phone}
                onChange={(newPhone, info) => {
                  setPhone(newPhone);
                  setCountryCode(info.countryCode);
                }}
                forceCallingCode
                disableFormatting
                required
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label={jobString}
                type="text"
                value={job}
                onChange={(e) => setJob(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-6">
              <TextField
                sx={{ width: '100%' }}
                label="Nombre(s)"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                // required
              />
            </div>
            <div className="col-md-6">
              <TextField
                sx={{ width: '100%' }}
                label="Apellido(s)"
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                // required
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-6">
              <TextField
                sx={{ width: '100%' }}
                label="Contraseña"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPW(e.target.value)}
                // required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? (
                          <VisibilityOffOutlinedIcon />
                        ) : (
                          <VisibilityOutlinedIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="col-md-6">
              <TextField
                sx={{ width: '100%' }}
                label="Repetir contraseña"
                type={showPassword ? 'text' : 'password'}
                value={verifyPassword}
                onChange={(e) => setVPW(e.target.value)}
                // required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? (
                          <VisibilityOffOutlinedIcon />
                        ) : (
                          <VisibilityOutlinedIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <FormControl variant="outlined" sx={{ width: '100%' }}>
                <InputLabel
                  id="select-outlined-label"
                  // required
                >
                  Tipo de contacto
                </InputLabel>
                <Select
                  labelId="select-outlined-label"
                  label="Tipo de contacto"
                  type="text"
                  value={contactTypeId}
                  onChange={(e) => setContactTypeId(e.target.value)}
                  // required
                >
                  <MenuItem value={1} selected={contactTypeDefaultU === 1}>
                    Principal
                  </MenuItem>
                  <MenuItem value={2} selected={contactTypeDefaultU === 2}>
                    Secundario
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label={notesString}
                type={'text'}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          form="update-cc-form"
          className="update-modal-button"
        >
          Guardar cambios
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCCUpdate;
